import { Flex, Grid } from "@chakra-ui/react";
import { useNewOrderStore } from "../../../stores/order.store";
import PageTitle from "../../../components/PageTitle";
import { EarSectionPreviousCommandRight } from "./EarSectionPreviousCommandRight";
import { EarSectionPreviousCommandLeft } from "./EarSectionPreviousCommandLeft";
import { OrdersNewPageBaseLayout } from "./OrdersNewPageBaseLayout";
import { OrdersNewPageBaseLayoutButton } from "./OrdersNewPageBaseLayoutButton";

export const ChooseRenewCommandsLayout = () => {
	const { goNextStep, fromCommand, reworkCommand } = useNewOrderStore();

	return (
		<OrdersNewPageBaseLayout>
			<Flex direction="column" gap={12} alignItems="center">
				<PageTitle>Oreille(s) concernée(s)</PageTitle>

				<Grid
					gridTemplateColumns="1fr 1fr"
					alignItems="flex-start"
					w="min(1600px,90vw)"
					justifyContent="space-between"
					gap={4}
				>
					<EarSectionPreviousCommandRight />
					<EarSectionPreviousCommandLeft />
				</Grid>

				<OrdersNewPageBaseLayoutButton
					onValidate={async () => {
						if (reworkCommand) {
							await fromCommand(reworkCommand);
						}
						goNextStep();
					}}
				/>
			</Flex>
		</OrdersNewPageBaseLayout>
	);
};
